"use client";

import { useCallback, useEffect } from "react";
import { useUser } from "@/hooks/use-user";
import { useBasketStore } from "@/stores/basket-store";

// TODO: Implement actual API calls
const fetchUserBasket = async (_userIdParam: string) => {
  // Mock implementation - replace with actual Shopify API call
  await new Promise((resolve) => setTimeout(resolve, 100));
  return [];
};

const saveBasketToUser = async (_userIdParam: string, _items: unknown[]) => {
  // Mock implementation - replace with actual Shopify API call
  await new Promise((resolve) => setTimeout(resolve, 100));
  // TODO: Replace with proper logging system
  // Saving basket for user: ${userIdParam} with ${items.length} items
};

/**
 * Hook that integrates basket state with authentication
 * Handles basket synchronization when user logs in/out
 */
export function useAuthBasket() {
  const { isAuthenticated, userId, isLoading } = useUser();
  const basketStore = useBasketStore();

  const handleUserLogin = useCallback(
    async (newUserId: string) => {
      try {
        // TODO: Fetch user's saved basket from Shopify API
        // For now, we'll just sync with empty basket
        const userBasketItems = await fetchUserBasket(newUserId);

        basketStore.syncWithUser(newUserId, userBasketItems);

        // TODO: Save current basket state to user's account
        await saveBasketToUser(newUserId, basketStore.items);
      } catch {
        // TODO: Replace with proper error logging system
        // Error: Failed to sync basket with user
      }
    },
    [basketStore]
  );

  const handleUserLogout = useCallback(() => {
    // Clear user data but keep basket items for guest checkout
    basketStore.clearUserData();
  }, [basketStore]);

  useEffect(() => {
    // Don't do anything while auth is loading
    if (isLoading) return;

    // Handle user login
    if (isAuthenticated && userId && basketStore.userId !== userId) {
      handleUserLogin(userId);
    }

    // Handle user logout
    if (!isAuthenticated && basketStore.userId) {
      handleUserLogout();
    }
  }, [
    isAuthenticated,
    userId,
    isLoading,
    basketStore.userId,
    handleUserLogin,
    handleUserLogout,
  ]);

  return {
    isBasketSynced: basketStore.userId === userId,
    lastSyncedAt: basketStore.lastSyncedAt,
  };
}
